import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "topbar-wrapper" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "item-text" }

import { PropType, ref } from 'vue';

import { classContains, getComputedStyle } from '@/common/tools/domOpts';

interface INavConfig {
  href: string;
  text: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginTopbar',
  props: {
  navConfig: {
    type: Array as PropType<INavConfig[]>,
    default: () => []
  }
},
  setup(__props) {



const bottomlineRef = ref();

const mouseenterBarItem = (event: any) => {
  if (!classContains(event.target, 'active-item')) {
    event.target.classList.add('active-item');
    lineMove(event.target);
  }
};

const mouseleaveBarItem = (event: any) => {
  const { classList } = event.target;
  if (classContains(event.target, 'active-item')) {
    classList.remove('active-item');
  }
};

const mouseLeaveRightBox = () => {
  lineHidden();
};

const lineMove = (target: any) => {
  // 过渡动画执行函数
  const { offsetLeft, clientWidth } = target;
  const bottomLineStyle = bottomlineRef.value.style;

  bottomLineStyle.display = 'block';

  bottomLineStyle.left = `${
    offsetLeft + parseInt(getComputedStyle(target as any, 'padding-left')!, 10)
  }px`;

  bottomLineStyle.width = `${
    clientWidth - parseInt(getComputedStyle(target as any, 'padding-left')!, 10) * 2
  }px`;

  // 给予浏览器20ms渲染间隔时间，触发过度动画
  setTimeout(() => {
    bottomLineStyle.background = '#ffffff';
    bottomLineStyle.opacity = 1;
  }, 20);
};

const lineHidden = () => {
  const display = getComputedStyle(bottomlineRef.value, 'display');

  const bottomLineStyle = bottomlineRef.value.style;

  // 如果bottomline目前已经是none状态，则无需污染dom内联样式
  if (display !== 'none') {
    bottomLineStyle.opacity = 0;
    setTimeout(() => {
      bottomLineStyle.display = 'none';
    }, 500);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "left-box" }, [
      _createElementVNode("div", { class: "login-milogo" }),
      _createTextVNode(" 国际零售工作台 ")
    ], -1)),
    (__props.navConfig.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "right-box",
          onMouseleave: mouseLeaveRightBox
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navConfig, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.text,
              class: "topbar-item",
              onMouseenter: mouseenterBarItem,
              onMouseleave: mouseleaveBarItem
            }, [
              _createElementVNode("a", {
                class: "topbar-item-text",
                href: item.href
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.text), 1)
              ], 8, _hoisted_2)
            ], 32))
          }), 128)),
          _createElementVNode("div", {
            ref_key: "bottomlineRef",
            ref: bottomlineRef,
            class: "topbar-bottom-line"
          }, null, 512)
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})